/* eslint-disable jsx-a11y/accessible-emoji, no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated. Edit ModalFullScreen.view to change it. More info: https://github.com/viewstools/docs/blob/master/UseViews/README.md#viewjs-is-auto-generated-and-shouldnt-be-edited
import React from 'react'
import useIsBefore from 'Logic/useIsBefore.js'
import { DialogOverlay as ViewsModalOverlay, DialogContent as ViewsModalOverlayContent } from '@reach/dialog'
import { css } from "emotion"

let styles = {}
styles.Vertical = css({label: 'Vertical',
  alignItems: "center",
bottom: 0,
justifyContent: "center",
left: 0,
position: "fixed",
right: 0,
top: 0,
zIndex: 1000,
  
transition: 'background-color 150ms linear',
willChange: 'background-color',
  backgroundColor: 'var(--backgroundColor)'})
styles.ModalContent = css({label: 'ModalContent',
  backgroundColor: "#ffffff",
borderBottomLeftRadius: 15,
borderBottomRightRadius: 15,
borderTopLeftRadius: 15,
borderTopRightRadius: 15,
maxHeight: "90%",
minHeight: 400,
paddingTop: 20,
boxShadow: "0px 10px 30px 0px rgba(0, 0, 0, 0.1)",
overflowY: "visible",
width: 800,
  
transition: 'opacity 100ms linear 100ms, transform 150ms ease-out 100ms',
willChange: 'opacity, transform',
  opacity: 'var(--opacity)',
transform: 'translateY(var(--translateY))'})

export default function ModalFullScreen({
  children,
  'data-testid': dataTestid,
  'data-view-path': dataViewPath,
  isSelected
}) {
    let isBefore = useIsBefore()
    
    
    
    
    

  return (<ViewsModalOverlay
 data-testid="ModalFullScreen.Vertical"
 data-view-path={dataViewPath}
 isOpen={true}
 style={{'--backgroundColor': isBefore ? "rgba(230, 230, 230, 0)" : "rgba(230, 230, 230, 0.8)"}}
 className={`views-block ${styles.Vertical}`}
>
<ViewsModalOverlayContent
 data-testid="ModalFullScreen.ModalContent"
 data-view-path={dataViewPath}
 style={{'--opacity': isBefore ? 0 : 1,'--translateY': isBefore ? "20px" : "0px"}}
 className={`views-block ${styles.ModalContent}`}
>
{typeof children === 'function'? children({ isSelected: isSelected
}) : null}
</ViewsModalOverlayContent>
</ViewsModalOverlay>)
}